import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca44aade"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "contact-inquiry-type",
  role: "group",
  "aria-label": "Reason"
}
const _hoisted_2 = ["id", "value", "disabled", "checked", "onChange"]
const _hoisted_3 = ["for"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["src"]

import { SupportInquiryType, supportInquiryTypeInfos } from '@webapp/gp/GroupAdminModel'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactInquiryType',
  props: {
    disabled: { type: Boolean },
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(supportInquiryTypeInfos), (t) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: t.value
      }, [
        _createElementVNode("input", {
          type: "radio",
          class: "btn-check",
          name: "inquiryType",
          id: t.value,
          value: t.value,
          disabled: _ctx.disabled,
          autocomplete: "off",
          checked: _ctx.modelValue == t.value,
          onChange: ($event: any) => (emit('update:modelValue', t.value))
        }, null, 40, _hoisted_2),
        _createElementVNode("label", {
          class: "btn btn-outline-primary",
          for: t.value
        }, [
          (t.iconText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(t.iconText), 1))
            : (typeof t.icon == 'string')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: t.icon
                }, null, 8, _hoisted_5))
              : (t.icon)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(t.icon), {
                    key: 2,
                    size: "1.8x"
                  }))
                : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(t.text), 1)
        ], 8, _hoisted_3)
      ], 64))
    }), 128))
  ]))
}
}

})